import { CALENDAR_INVITE_CATEGORIES } from '@/constants/templates-category';

interface FontControlsArgs {
  /** EmailTemplates renders inline (send mode) rather than behind a modal. */
  renderOnMount?: boolean;
  /** Present only when the composer submits/sends an email. */
  emailFormSubmit?: unknown;
  /** Allowed template category/categories for this composer instance. */
  category?: string | string[];
}

/**
 * Font family/size controls are enabled only when the email composer actually
 * SENDS an email — i.e. it is rendered inline (`renderOnMount`) with a submit
 * handler (`emailFormSubmit`) — AND the category is not a calendar invite
 * (those strip inline font styling on send, so the controls would be a no-op).
 */
export const shouldEnableEmailFontControls = ({
  renderOnMount = false,
  emailFormSubmit = undefined,
  category,
}: FontControlsArgs): boolean => {
  const isSendMode = renderOnMount && Boolean(emailFormSubmit);
  if (!isSendMode) return false;

  const categories = Array.isArray(category)
    ? category
    : category
      ? [category]
      : [];
  const isCalendarInvite = categories.some((c) =>
    CALENDAR_INVITE_CATEGORIES.includes(c)
  );
  return !isCalendarInvite;
};
